<template>
  <div class="space-y-6">
    <!-- Информация о статье -->
    <div class="p-4 rounded bg-gray-100 dark:bg-secondary-bg">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm mb-1 text-gray-900 dark:text-primary">Slug</label>
          <input v-model="form.slug" class="w-full bg-white dark:bg-background p-2 rounded text-gray-900 dark:text-primary border border-gray-300 dark:border-gray-700" placeholder="about-us" />
        </div>
        <div class="flex items-center space-x-3 mt-6 md:mt-0">
          <label class="text-sm text-gray-900 dark:text-primary">Видимость</label>
          <input type="checkbox" v-model="form.visible" />
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm mb-1 text-gray-900 dark:text-primary">Заголовок</label>
          <input v-model="form.title" class="w-full bg-white dark:bg-background p-2 rounded text-gray-900 dark:text-primary border border-gray-300 dark:border-gray-700" placeholder="О нас" />
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm mb-1 text-gray-900 dark:text-primary">Короткое описание</label>
          <textarea v-model="form.description" class="w-full bg-white dark:bg-background p-2 rounded min-h-[96px] text-gray-900 dark:text-primary border border-gray-300 dark:border-gray-700" placeholder="Короткое описание статьи" />
        </div>
      </div>
      <div class="mt-4 flex items-center justify-end space-x-2">
        <button 
          class="px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500" 
          @click="openTestUrl"
          :disabled="!form.slug"
        >
          Открыть на тест
        </button>
        <button 
          class="px-4 py-2 rounded bg-gray-600 text-white hover:bg-gray-500" 
          @click="openProdUrl"
          :disabled="!form.slug"
        >
          на прод
        </button>
        <button class="px-4 py-2 rounded bg-accent text-white" @click="saveArticle">Сохранить статью</button>
      </div>
    </div>

    <!-- Конструктор блоков -->
    <BlogConstructor
      :article-id="articleId"
      :blocks="blocks"
      @blocks-updated="onBlocksUpdated"
    />
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import BlogConstructor from './BlogConstructor.vue';
import { fetchBlogArticle, updateBlogArticle } from '../../services/api';

export default {
  name: 'BlogEditor',
  components: { BlogConstructor },
  props: {
    articleId: { type: Number, required: true }
  },
  data() {
    return {
      form: { slug: '', title: '', description: '', visible: true },
      blocks: []
    }
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      const data = await fetchBlogArticle(this.articleId);
      this.form.slug = data.slug;
      this.form.title = data.title;
      this.form.description = data.description || '';
      this.form.visible = data.visible;
      this.blocks = Array.isArray(data.blocks) ? data.blocks : [];
    },
    async saveArticle() {
      await updateBlogArticle(this.articleId, {
        slug: this.form.slug,
        title: this.form.title,
        description: this.form.description || null,
        visible: this.form.visible,
      });
      const toast = useToast();
      toast.success('Статья сохранена');
      await this.load();
    },
    openTestUrl() {
      if (!this.form.slug) return;
      const url = `https://t3st.chapterfour.ru/presentation/${this.form.slug}`;
      window.open(url, '_blank');
    },
    openProdUrl() {
      if (!this.form.slug) return;
      const url = `https://chapterfour.ru/presentation/${this.form.slug}`;
      window.open(url, '_blank');
    },
    async onBlocksUpdated(updatedBlocks) {
      if (updatedBlocks) {
        // Если переданы обновленные блоки, используем их
        this.blocks = updatedBlocks;
      } else {
        // Иначе перезагружаем данные с сервера
        await this.load();
      }
    }
  }
}
</script>

<style scoped>
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>


